import { FormattedMessage } from 'react-intl';

import AssistantGif from 'domain/assistant/AssistantGif';
import { SessionMainText } from 'domain/assistant/session-elements';
import { ASSISTANTS } from 'utils/constants/assistant-steps';
import { ROUTE_ASSISTANT } from 'utils/constants/routes';
import { HistoryProps } from 'utils/history';
import ExplanationScreen from '../ExplanationScreen';

const SolutionDoneScreen = ({ location }: HistoryProps) => {
  return (
    <ExplanationScreen
      barProgress={100}
      sidebarHeadline={ASSISTANTS.creative_session.step3_2.header}
      header={<FormattedMessage id="assistant solutions header" />}
      headerStep={ASSISTANTS.creative_session.step3_2.header}
      buttonTextId="assistant finish button"
      nextRoute={ROUTE_ASSISTANT}
      nextRouteIsAbsolute={true}
      sidebarScrollTo="solutions"
      showHeader="solutions"
      location={location}
    >
      <SessionMainText>
        <FormattedMessage id="assistant solutions done" />
      </SessionMainText>

      <AssistantGif />
    </ExplanationScreen>
  );
};

export default SolutionDoneScreen;
